import React from "react";
import { Table } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import CircularProgress from "@material-ui/core/CircularProgress";

const PromoCodesTable = ({ promoLists, onSelectPromo, onDeleteClick, onViewUsage, isLoading, skip, limit }) => {
  return (
    <>
      <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
        <div className="tblmrgn mt-0">
          <div className="mt-5">
            <div>
              <Table hover responsive className="mb-0 default_table with_hoverbtn mrpdng_tbl">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Free Coins</th>
                    <th>Max Usage</th>
                    <th>Used By</th>
                    <th>Status</th>
                    <th className="wd-120">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <div className="basic-verification-loader text-center">
                          <CircularProgress />
                        </div>
                      </td>
                    </tr>
                  ) : promoLists && promoLists.data && promoLists.data.length > 0 ? (
                    promoLists.data.map((promo, index) => (
                      <tr key={promo._id || index}>
                        <td>
                          <span className="f-w-500">
                            {skip * limit + (index + 1)}
                          </span>
                        </td>
                        <td>
                          <span className="f-w-500">{promo.name}</span>
                        </td>
                        <td>{promo.code}</td>
                        <td>{promo.freeCoins}</td>
                        <td>
                          {promo.maxUsage ? promo.maxUsage : 'Unlimited'}
                        </td>
                        <td>
                          <span className={`f-w-500 ${promo.maxUsage && promo.usageCount >= promo.maxUsage ? 'text-danger' : 'text-success'}`}>
                            {promo.usageCount || 0} {promo.maxUsage ? `/ ${promo.maxUsage}` : ''}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${promo.maxUsage && promo.usageCount >= promo.maxUsage ? 'badge-danger' : 'badge-success'}`}>
                            {promo.maxUsage && promo.usageCount >= promo.maxUsage ? "Limit Reached" : "Active"}
                          </span>
                        </td>
                        <td>
                          <div className="d-flex">
                            <a 
                              title="View Usage" 
                              className="btn btn-icon btn-light btn-hover-info btn-sm mr-2" 
                              onClick={() => onViewUsage(promo)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-info">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
                              </span>
                            </a>
                            <a 
                              title="Delete" 
                              className="btn btn-icon btn-light btn-hover-danger btn-sm" 
                              onClick={() => onDeleteClick(promo)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-danger">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
                              </span>
                            </a>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        No Record Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromoCodesTable; 